import { Injectable, inject } from '@angular/core';
import { UiService } from '../services/ui.service';
import { GLOBAL_CONSTANT } from '../constants/global.constant';

@Injectable({
  providedIn: 'root',
})
export class CookieBannerService {
  private ui = inject(UiService);
  callCookieBanner(cname: string[], cvalue: string, exMins: number): void {
    for (let i = GLOBAL_CONSTANT.DEFAULT_INITIALIZER; i < cname.length; i++) {
      const d = new Date();
      d.setTime(d.getTime() + exMins * 60 * 1000);
      const expires = 'expires=' + d.toUTCString();
      document.cookie =
        cname[i] + '=' + cvalue + ';' + expires + ';path=/' + ';domain=' + window.location.hostname;
    }
  }

  cookieSettings(): void {
    const langBanner = document.querySelector('#onetrust-consent-sdk');
    if (langBanner) {
      langBanner.remove();
    }
    this.callCookieBanner(
      ['OptanonConsent', 'OptanonAlertBoxClosed'],
      GLOBAL_CONSTANT.EMPTY_STRING,
      GLOBAL_CONSTANT.DEFAULT_INITIALIZER
    );
    this.deleteCookies(['OptanonConsent', 'OptanonAlertBoxClosed']);
    this.callingScript();
  }

  deleteCookies(cookies: string[]) {
    cookies.forEach((name) => {
      document.cookie =
        name +
        '=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=' +
        window.location.hostname;
    });
  }

  callingScript() {
    const existingScript = document.getElementById('cookie-script');
    if (existingScript) {
      existingScript.remove();
    }
    const script = document.createElement('script');
    script.id = 'cookie-script';
    script.src = 'https://cdn.cookielaw.org/scripttemplates/otSDKStub.js';
    script.setAttribute('data-document-language', 'true');
    script.setAttribute('type', 'text/javascript');
    script.setAttribute('charset', 'UTF-8');
    if (this.ui.environmentDomain === 'PROD') {
      script.setAttribute('data-domain-script', 'ae27a7fc-9246-4aee-93db-8bf4beb8e2b2');
    } else if (this.ui.environmentDomain === 'TEST') {
      script.setAttribute('data-domain-script', '2d6f8900-6dc1-4195-95e7-c26f923c1bda-test');
    } else {
      script.setAttribute('data-domain-script', '0c30f3b6-12ac-4d95-8d4d-98fc897c7492-test');
    }
    document.head.appendChild(script);
  }
}
